import React, { useState, useEffect } from "react";
import SidePanel from "../../components/SidePanel";
import "../../styles/Layout.css";
import "../../styles/Components.css";
import "../../styles/Game.css";

const TestMode = ({ poseData }) => {
  const [leftPunchCount, setLeftPunchCount] = useState(0);
  const [rightPunchCount, setRightPunchCount] = useState(0);

  useEffect(() => {
    if (poseData && poseData.actions.left.punched) {
      setLeftPunchCount((prev) => prev + 1);
    }
  }, [poseData]);

  useEffect(() => {
    if (poseData && poseData.actions.right.punched) {
      setRightPunchCount((prev) => prev + 1);
    }
  }, [poseData]);

  if (!poseData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="test-mode-layout">
      <SidePanel
        side="left"
        punchCount={leftPunchCount}
        conditions={poseData.conditions.left}
      />
      <SidePanel
        side="right"
        punchCount={rightPunchCount}
        conditions={poseData.conditions.right}
      />
    </div>
  );
};

export default TestMode;
